import {Logger} from './logger';
import {Cache, ResourceOptions} from './cache-storage';
import {Bounds} from '../css/layout/bounds';

export type ContextOptions = {
    logging: boolean;
    cache?: Cache;
    liveDOM?: boolean;
} & ResourceOptions;

export class Context {
    private readonly instanceName = `#${Context.instanceCount++}`;
    readonly logger: Logger;
    readonly cache: Cache;
    readonly liveDOM: boolean;
    private readonly cleanups: Array<() => void>;

    private static instanceCount = 1;

    constructor(options: ContextOptions, public windowBounds: Bounds) {
        this.logger = new Logger({id: this.instanceName, enabled: options.logging});
        this.cache = options.cache ?? new Cache(this, options);
        this.liveDOM = options.liveDOM ?? false;
        this.cleanups = [];
    }

    applyTemporaryStyle(element: HTMLElement, property: keyof CSSStyleDeclaration, value: string): void {
        const propertyName = property as string;
        if (this.liveDOM) {
            const previous = element.style.getPropertyValue(propertyName);
            const priority = element.style.getPropertyPriority(propertyName);
            this.cleanups.push(() => {
                if (previous) {
                    element.style.setProperty(propertyName, previous, priority);
                } else {
                    element.style.removeProperty(propertyName);
                }
            });
        }
        element.style.setProperty(propertyName, value);
    }

    cleanup(): void {
        while (this.cleanups.length) {
            const restore = this.cleanups.pop();
            if (restore) {
                restore();
            }
        }
    }
}
